import { render, staticRenderFns } from "./PdfPage.vue?vue&type=template&id=c92c6f54&scoped=true&"
import script from "./PdfPage.vue?vue&type=script&lang=js&"
export * from "./PdfPage.vue?vue&type=script&lang=js&"
import style0 from "./PdfPage.vue?vue&type=style&index=0&id=c92c6f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92c6f54",
  null
  
)

export default component.exports